// This file is created for developer who could manage keys of localStorage clearly.
export default {
  // tid
  // {string}
  'TID': 'TID',
  // 用户登录信息
  // {object}
  'USER_INFO': 'USER_INFO',
  // 是否展示功能介绍
  // {'true' | 'false'}
  'SHOW_FEATURE_INTRODUCE': 'SHOW_FEATURE_INTRODUCE',
  // '0' 表示关，不提示
  // '1' 表示开，要提示
  'UNAUTHORIZED_NOTICE_STATE': 'UNAUTHORIZED_NOTICE_STATE',
  // 疾病搜索记录
  'DISEASE_SEARCH_HISTORY_LIST': 'DISEASE_SEARCH_HISTORY_LIST',
  // 药品搜索记录
  'DRUG_SEARCH_HISTORY_LIST': 'DRUG_SEARCH_HISTORY_LIST'
}
